import React, { useEffect, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { useLocation } from 'react-router-dom';
const CorcymBeatPopup = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [animate, setAnimate] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/") {
      setShowPopup(true);
    setTimeout(() => setAnimate(true), 50);
    }
  }, []);

  const closePopup = () => {
    setAnimate(false);
    setTimeout(() => setShowPopup(false), 300);
  };

  if (!showPopup) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-1000">
      <div
        style={{
          backgroundImage: "url(/images/corcym-beat/bg.jpg)",
          minWidth: "950px",
          width: "950px",
          height: "480px",
        }}
        className={`relative bg-cover scale-40   sm:scale-50 md:scale-75 lg:scale-80 xl:scale-100 bg-center flex items-center justify-start px-14 py-8 transform transition duration-300 ease-out ${animate
            ? "opacity-100  translate-y-0"
            : "opacity-0 -translate-y-6"
          }`}
      >
        <button
          className="absolute -top-8 -right-8 text-3xl text-white hover:text-black focus:outline-none"
          onClick={closePopup}
        >
          <AiOutlineClose />
        </button>


        <div className=" h-full">
          <img style={{ width: "250px" }} src="/images/corcym-beat/Exe_Logo_Corcymbeat_2025.png" alt="" className="" />
          <div style={{ width: "255px" }} className="">
            <p className="text-red-primary font-bold text-[19px] mt-2">Beating Hearts, Saving Hearts</p>
            <div className="bg-blue-primary pl-14 -ml-14">
              <p style={{ fontWeight: 500 }} className=" text-white py-2 text-sm">Starting September 1st, join us!</p>

            </div>
          </div>
            <p style={{ fontWeight: 500 }} className="text-blue-primary py-2 text-sm">#CORCYMbeat2025 is back for its fourth year, a global <br />
              challenge to support Team Heart’s mission in Rwanda.</p>

            <p style={{ fontWeight: 500 }} className="text-blue-primary text-sm ">Run, bike, or swim, every kilometer you cover helps <br />
              provide life-saving cardiac care to those who need it most.</p>
            <p className="font-bold text-red-primary text-sm mb-3">Take part, track your progress, and make an impact.</p>

            <a href="https://corcymbeat.corcym.com/" target="_blank" className="bg-red-primary cursor-pointer shadow-xl px-3  py-1.5 text-sm text-white ">LEARN MORE AND JOIN THE MOVEMENT</a>
        </div>


      </div>
    </div>
  );
};

export default CorcymBeatPopup;
